import React from "react";
import styled, { withTheme, css } from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import { Button } from "@vitalsource/vstui";
import PropTypes from "prop-types";
import { jsQueries } from "../mediaquery/breakpoints";
import withMatchMedia from "../mediaquery/with-match-media";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import { t } from "../../core/translate";
import { CaretLeftLarge, CaretRightLarge } from "@vitalsource/vstui-icons";
import { OffScreenStyles } from "../mixins";
import AccessibleSkipButton from "../accessible-skip-button";

const CaretButton = createThemedComponent(Button, props => ({
  Button_paddingHorizontal_withIconMedium: "20px",
  Button_fontSize_medium: "26px",
  Button_paddingHorizontal_medium: 0
}));

const CaretLeft = styled(CaretLeftLarge)`
  height: 20px;
  width: 20px;
`;

const CaretRight = styled(CaretRightLarge)`
  height: 20px;
  width: 20px;
`;

const baseHeaderStyle = css`
  background: none;
  border: 0;
  font-size: 2.6rem;
  padding: 0;
`;

const StyledButton = styled.div`
  align-items: center;
  display: flex;
  ${baseHeaderStyle};
  &:hover {
    .category-head-label {
      text-decoration: none;
    }
  }
`;

const StyledTitle = styled.div`
  align-items: center;
  display: flex;
  ${baseHeaderStyle};
  color: ${cloud.getShade(10)};
`;

const HiddenHeader = styled.h2`
  ${OffScreenStyles};
`;

const HiddenButtonLabel = styled.div.attrs({
  "aria-hidden": true
})`
  color: ${cloud.getShade(10)};
`;

const CaretContainer = styled.div`
  font-size: 2.6rem;
  font-weight: 500;
  display: inline-block;
  vertical-align: middle;
  line-height: 0;
  padding-left: ${props => (props.plainText ? `20px` : `0px`)};
  color: ${props =>
    props.plainText && props.caretRight
      ? `${props.theme.color.primary.getShade(7)}`
      : `${cloud.getShade(10)}`};
`;

function backButton(caretLeft, lastLabel, onClick, label) {
  if (caretLeft) {
    const toolTip = lastLabel
      ? t("filter.library-back", "Go Back", { location: lastLabel })
      : t("base.back", "Go Back");

    return (
      <CaretContainer plainText={false}>
        <HiddenHeader>{label}</HiddenHeader>
        <CaretButton
          naked
          label={toolTip}
          iconStart={<CaretLeft />}
          onClick={onClick}
        >
          <HiddenButtonLabel>{label}</HiddenButtonLabel>
        </CaretButton>
      </CaretContainer>
    );
  }
}

function drillButton(caretRight, onClick, label) {
  if (label) {
    let diveHeaderContent = (!onClick && label) || null;
    if (caretRight) {
      diveHeaderContent = (
        <CaretButton naked iconEnd={<CaretRight />} onClick={onClick}>
          {label}
        </CaretButton>
      );
    }

    return (
      <CaretContainer plainText={!onClick} caretRight={caretRight}>
        {diveHeaderContent}
      </CaretContainer>
    );
  }
  return false;
}

function skipAheadButton(skipAhead, skipAheadClick, onClick, focusRef) {
  const elementType = onClick;
  if (skipAhead) {
    return (
      <AccessibleSkipButton
        skipClick={skipAheadClick}
        label={t("base.skip-ahead", "Skip Ahead")}
        top={-18}
        left={elementType ? 0 : 25}
        focusRef={focusRef}
      />
    );
  }
  return false;
}

function CategoryHead({
  label,
  onClick,
  caretLeft,
  caretRight,
  lastLabel,
  skipAhead,
  skipAheadClick,
  focusRef
}) {
  const ContentContainer = onClick ? StyledButton : StyledTitle;

  return (
    <ContentContainer>
      {backButton(caretLeft, lastLabel, onClick, label)}
      {drillButton(caretRight, onClick, label)}
      {skipAheadButton(skipAhead, skipAheadClick, onClick, focusRef)}
    </ContentContainer>
  );
}

CategoryHead.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  lastLabel: PropTypes.string,
  count: PropTypes.number,
  skipAheadClick: PropTypes.func
};

export default withTheme(withMatchMedia(jsQueries.medium)(CategoryHead));
